import React from "react";
import { Link } from "react-router-dom";
import { Grid, Image } from "semantic-ui-react";
import { ProfileData } from "../../../types/siteTypes";
import { Body1 } from "../../../components/value-cssmodules/TextComponent";

type Props = {
  profile: ProfileData;
};
const ProfileItem: React.FC<Props> = ({ profile: { photo, handle, user } }) => {
  if (!user) return null;
  return (
    <Grid.Column mobile={8} computer={4}>
      <Link to={`/profile/${user._id}`}>
        <Image src={photo ? photo.url : "/photos/no-photo.jpg"} />
        <Body1>{handle}</Body1>
      </Link>
    </Grid.Column>
  );
};

export default ProfileItem;
